document.querySelectorAll('.Megamenu_product_grid_3_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 14,
        slidesPerGroup: 1,
        slidesPerView: 3,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});

document.querySelectorAll('.Megamenu_product_grid_4_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 14,
        slidesPerGroup: 1,
        slidesPerView: 4,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});

document.querySelectorAll('.Megamenu_product_grid_5_slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: false,
        grabCursor: false,
        spaceBetween: 14,
        slidesPerGroup: 1,
        slidesPerView: 5,
        watchSlidesProgress: true,
        draggable: !0,
        autoHeight: !1,
        watchOverflow: !0,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: !0,
        breakpoints: {
            0: {
                freeMode: !1
            },
            750: {
            },
            990: {
            },
            1200: {
            },
            1440: {
            }
        }
    })
  }
});